import { createElement, lazy } from 'react';
import type { FeatureModule } from '@/app/contract';
import { APP_ROUTES } from '@/app/paths';
import { registerNamespace } from '@/i18n';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';
import { registerFeatureRuntime } from '@/app/runtimes';
import { ReadingPositionRuntime } from './timeline/ReadingPositionRuntime';

registerNamespace('chat', { en, 'zh-Hans': zh });
const unregisterReading = registerFeatureRuntime('chat.reading', ReadingPositionRuntime, { phase: 'services' });
if (import.meta.hot) import.meta.hot.dispose(unregisterReading);

const ChatScreen = lazy(() => import('./screens/ChatScreen'));
// The shell's route loader resolves to this function; the screen chunk stays lazy.
function ChatRoute() { return createElement(ChatScreen); }
const feature: FeatureModule = { id: 'chat', routes: [{ ...APP_ROUTES.chat, component: ChatRoute }] };

export default feature;

export {
  chatAccessories,
  partRenderer,
  registerChatAccessory,
  registerPartRenderer,
  type ChatAccessoryProps,
  type ChatAccessorySlot,
  type PartRendererProps,
} from './registry';

export {
  rendererForPart,
  registerMessageAccessory,
  messageAccessoriesForChat,
  registerMessageGroupRenderer,
  messageGroupRenderers,
  registerMessageAction,
  messageActions,
  type MessageAccessoryProps,
  type MessageGroupRendererProps,
  type MessageGroupRegistration,
  type MessageActionContext,
  type MessageActionRegistration,
} from './registry';
export { ChatMediaViewer, type ChatMediaViewerProps } from './public';
export { StoppedSeatBar, type StoppedSeatBarProps } from './components/StoppedSeatBar';
